import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';

const BalancePage = lazyWithRetry(() => import('../pages/BalancePage.tsx'));

const balanceNode = {
  component: BalancePage,
} satisfies ComponentPage;

const cashflowRoutes: ComponentOrMapping = {
  erp: {
    cashflow: {
      balance: balanceNode,
    },
  },
};

export default cashflowRoutes;
